import React from 'react'
import './ReportsSkeleton.css'

type ReportsSkeletonProps = {
  variant?: 'bundle' | 'custom' | 'presets'
}

const ReportsSkeleton: React.FC<ReportsSkeletonProps> = ({
  variant = 'bundle',
}) => {
  if (variant === 'custom') {
    return (
      <div
        className="reports-bundle-skeleton reports-bundle-skeleton--custom"
        role="status"
        aria-label="Loading custom report builder"
      >
        <div className="reports-bundle-skeleton-toolbar">
          <span className="reports-bundle-skeleton-chip" />
          <span className="reports-bundle-skeleton-chip" />
          <span className="reports-bundle-skeleton-chip reports-bundle-skeleton-chip--wide" />
        </div>
        <div className="reports-bundle-skeleton-custom-body">
          <div className="reports-bundle-skeleton-aside">
            <div className="reports-bundle-skeleton-card reports-bundle-skeleton-shimmer">
              <span className="reports-bundle-skeleton-line reports-bundle-skeleton-line--value" />
            </div>
            <div className="reports-bundle-skeleton-card reports-bundle-skeleton-aside-card reports-bundle-skeleton-shimmer">
              <span className="reports-bundle-skeleton-line reports-bundle-skeleton-line--title" />
              <span className="reports-bundle-skeleton-line" />
              <span className="reports-bundle-skeleton-line" />
              <span className="reports-bundle-skeleton-line reports-bundle-skeleton-line--value" />
            </div>
            <div className="reports-bundle-skeleton-card reports-bundle-skeleton-aside-card reports-bundle-skeleton-shimmer">
              <span className="reports-bundle-skeleton-line reports-bundle-skeleton-line--title" />
              <span className="reports-bundle-skeleton-line" />
              <span className="reports-bundle-skeleton-line reports-bundle-skeleton-line--value" />
              <span className="reports-bundle-skeleton-line" />
            </div>
            <div className="reports-bundle-skeleton-aside-actions">
              <span className="reports-bundle-skeleton-chip" />
              <span className="reports-bundle-skeleton-chip" />
            </div>
          </div>
          <div className="reports-bundle-skeleton-preview">
            <div className="reports-bundle-skeleton-kpis">
              {Array.from({ length: 4 }).map((_, index) => (
                <div
                  key={`kpi-${index}`}
                  className="reports-bundle-skeleton-kpi reports-bundle-skeleton-shimmer"
                >
                  <span className="reports-bundle-skeleton-line reports-bundle-skeleton-line--title" />
                  <span className="reports-bundle-skeleton-line reports-bundle-skeleton-line--value" />
                </div>
              ))}
            </div>
            <div className="reports-bundle-skeleton-card reports-bundle-skeleton-shimmer">
              <span className="reports-bundle-skeleton-line reports-bundle-skeleton-line--title" />
              <span className="reports-bundle-skeleton-block" />
            </div>
          </div>
        </div>
      </div>
    )
  }

  if (variant === 'presets') {
    return (
      <div
        className="reports-bundle-skeleton reports-bundle-skeleton--presets"
        aria-hidden="true"
      >
        <div className="reports-bundle-skeleton-toolbar reports-bundle-skeleton-toolbar--presets">
          <div className="reports-bundle-skeleton-toolbar-tabs">
            <span className="reports-bundle-skeleton-chip reports-bundle-skeleton-chip--wide" />
            <span className="reports-bundle-skeleton-chip reports-bundle-skeleton-chip--wide" />
            <span className="reports-bundle-skeleton-chip reports-bundle-skeleton-chip--wide" />
            <span className="reports-bundle-skeleton-chip reports-bundle-skeleton-chip--wide" />
          </div>
          <span className="reports-bundle-skeleton-chip reports-bundle-skeleton-chip--search" />
        </div>
        <div className="reports-bundle-skeleton-card reports-bundle-skeleton-table reports-bundle-skeleton-shimmer">
          <div className="reports-bundle-skeleton-table-row reports-bundle-skeleton-table-row--header">
            <span />
            <span />
            <span />
            <span />
            <span />
          </div>
          {Array.from({ length: 8 }).map((_, rowIndex) => (
            <div
              key={`row-${rowIndex}`}
              className="reports-bundle-skeleton-table-row"
            >
              <span />
              <span />
              <span />
              <span />
              <span />
            </div>
          ))}
        </div>
      </div>
    )
  }

  return (
    <div className="reports-bundle-skeleton" aria-hidden="true">
      <div className="reports-bundle-skeleton-toolbar">
        <span className="reports-bundle-skeleton-chip" />
        <span className="reports-bundle-skeleton-chip" />
        <span className="reports-bundle-skeleton-chip reports-bundle-skeleton-chip--wide" />
      </div>
      <div className="reports-bundle-skeleton-kpis">
        {Array.from({ length: 5 }).map((_, index) => (
          <div
            key={`kpi-${index}`}
            className="reports-bundle-skeleton-kpi reports-bundle-skeleton-shimmer"
          >
            <span className="reports-bundle-skeleton-line reports-bundle-skeleton-line--title" />
            <span className="reports-bundle-skeleton-line reports-bundle-skeleton-line--value" />
          </div>
        ))}
      </div>
      <div className="reports-bundle-skeleton-charts">
        <div className="reports-bundle-skeleton-card reports-bundle-skeleton-shimmer">
          <span className="reports-bundle-skeleton-line reports-bundle-skeleton-line--title" />
          <span className="reports-bundle-skeleton-block" />
        </div>
        <div className="reports-bundle-skeleton-card reports-bundle-skeleton-shimmer">
          <span className="reports-bundle-skeleton-line reports-bundle-skeleton-line--title" />
          <span className="reports-bundle-skeleton-block" />
        </div>
      </div>
      <div className="reports-bundle-skeleton-card reports-bundle-skeleton-table reports-bundle-skeleton-shimmer">
        <span className="reports-bundle-skeleton-line reports-bundle-skeleton-line--title" />
        {Array.from({ length: 6 }).map((_, rowIndex) => (
          <div
            key={`row-${rowIndex}`}
            className="reports-bundle-skeleton-table-row"
          >
            <span />
            <span />
            <span />
            <span />
          </div>
        ))}
      </div>
    </div>
  )
}

export default ReportsSkeleton
